var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgTreeLarge(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 31 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M15.744 0c.328 0 .656.188.844.469l6.515 8.297c.235.375.282.796.094 1.218-.187.375-.562.61-.984.61h-.797l3.14 4.734c.235.328.282.797.094 1.125-.234.375-.609.61-1.03.61H22.54l3.469 5.203c.234.375.281.797.093 1.172-.187.375-.609.562-.984.562H6.37c-.422 0-.797-.188-1.031-.563a1.165 1.165 0 01.094-1.171l3.515-5.203H7.822c-.422 0-.797-.235-1.031-.61a1.08 1.08 0 01.094-1.125l3.14-4.734H9.23c-.422 0-.797-.235-.985-.61a1.254 1.254 0 01.094-1.218L14.854.469c.187-.281.515-.469.89-.469zm-4.219 8.344h.61c.422 0 .797.234.984.61.188.374.188.796-.047 1.124l-3.187 4.735h1.172c.421 0 .796.234.984.609.188.328.188.797-.047 1.125L8.48 21.75h14.484l-3.516-5.203c-.234-.328-.234-.797-.047-1.125.188-.375.563-.61.985-.61h1.172l-3.188-4.734c-.234-.328-.234-.75-.047-1.125.188-.375.563-.61.985-.61h.609L15.744 3l-4.219 5.344z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgTreeLarge);
export default ForwardRef;
